.discord-embed .discord-embed-field {
	font-size: 0.875rem;
	line-height: 1.125rem;
	min-width: 0;
	font-weight: 400;
	grid-column: 1/13;
}

.discord-embed .discord-embed-field .discord-field-title {
	color: #ffffff;
	font-weight: 600;
	font-size: 0.875rem;
	line-height: 1.125rem;
	min-width: 0;
	margin-bottom: 2px;
}

.discord-embed .discord-embed-field.discord-inline-field {
	flex-grow: 1;
	flex-basis: auto;
	min-width: 150px;
}

.discord-light-theme .discord-embed .discord-embed-field .discord-field-title {
	color: #747f8d;
}

.discord-embed-inline-field-3 {
	grid-column: 9/13 !important;
}

.discord-embed-inline-field-2 {
	grid-column: 5/9 !important;
}

.discord-embed-inline-field-1 {
	grid-column: 1/5 !important;
}
